import AdminUsers from "@/components/admin/users/AdminUsers";

export default [
  {
    path: "/admin/users",
    name: "AdminUsers",
    component: AdminUsers,
    meta: {
      requiresAuthentication: true
    }
  }
];
